import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getRegister, getSignIn } from '../redux/actions/actions.js';
import Swal from 'sweetalert2';

export const useSignUpSignIn = () => {

    const [isRegisterActive, setIsRegisterActive] = useState(false);
    const [isSignIn, setIsSignIn] = useState({
        email: "",
        password: ""
    });
    const [isSignUp, setIsSignUp] = useState({
        name: "",
        email: "",
        password: ""
    });
    const [error, setError] = useState({});

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const validateName = (name) => {
        if (!name || name.trim() === "") {
            return "El nombre es requerido";
        } else if (!/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/.test(name)) {
            return Swal.fire({
                title: 'Error',
                text: 'El nombre solo puede contener letras y espacios en blanco',
                icon: 'error',
                confirmButtonText: 'Aceptar',
                timer: 3500,
            });
        }
        return null;
    };

    const validateEmail = (email) => {
        if (!email || email.trim() === "") {
            return "El Email es requerido";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            return Swal.fire({
                title: 'Error',
                text: "El Email no es válido",
                icon: 'error',
                confirmButtonText: 'Aceptar',
                timer: 3500,
            });
        }
        return null;
    };

    const validatePassword = (password) => {
        if (!password || password.trim() === "") {
            return "La contraseña es requerida";
        } else if (password.length < 6) {
            return Swal.fire({
                title: 'Error',
                text: "La contraseña debe tener al menos 6 caracteres",
                icon: 'error',
                confirmButtonText: 'Aceptar',
                timer: 3500,
            });
        } else if (!/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/.test(password)) {
            return Swal.fire({
                title: 'Error',
                text: "La contraseña debe incluir letras, números y al menos un carácter especial",
                icon: 'error',
                confirmButtonText: 'Aceptar',
                timer: 3500,
            });
        }
        return null;
    };

    const handleError = (input, formType) => {
        let error = {};

        if (formType === "signup") {
            const nameError = validateName(input.name);
            if (nameError) error.name = nameError;
        }

        const emailError = validateEmail(input.email);
        if (emailError) error.email = emailError;

        const passwordError = validatePassword(input.password);
        if (passwordError) error.password = passwordError;

        return error;
    };

    const signUpChooser = () => {
        setIsRegisterActive(true);
    };
    const signInChooser = () => {
        setIsRegisterActive(false);
    };
    const handleChangeSignIn = (e) => {
        const { name, value } = e.target;
        setIsSignIn({ ...isSignIn, [name]: value });
    };

    const handleChangeSignUp = (e) => {
        setIsSignUp({ ...isSignUp, [e.target.name]: e.target.value });
    };

    const handleSubmitSignUp = (e) => {
        e.preventDefault();
        const validationErrors = handleError(isSignUp, "signup");
        if (Object.keys(validationErrors).length > 0) {
            setError(validationErrors);
            return;
        }
        dispatch(getRegister(isSignUp, setIsSignUp));
    };

    const handleSubmitSignIn = (e) => {
        e.preventDefault();
        const validationErrors = handleError(isSignIn, "signin");
        if (Object.keys(validationErrors).length > 0) {
            setError(validationErrors);
            return;
        }
        dispatch(getSignIn(isSignIn, setIsSignIn, navigate));
    };

    const handleViewPassword = (e) => {
        e.preventDefault();
        const passwordInput = document.getElementById("password");
        if (passwordInput.type === "password") {
            passwordInput.type = "text";
        } else {
            passwordInput.type = "password";
        }
    }

    return {
        isRegisterActive,
        isSignIn,
        isSignUp,
        signUpChooser,
        signInChooser,
        handleChangeSignIn,
        handleChangeSignUp,
        handleSubmitSignUp,
        handleSubmitSignIn
    };
};